import "./Landing.css";

import { IDFines, SearchBy } from "../../models/fineModels";
import { search, searchByID } from "../../api/infringement";
import { setAcceptGuilt, setAcceptTerms } from "../../store/fine/guiltActions";
import {
  setAccount,
  setCurrentStep,
  setIDFines,
  setSearchedID,
} from "../../store/fine/fineActions";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { useEffect, useState } from "react";

import COCTSVG from "../../assets/images/coct-logo.svg";
import Carousel from "../../components/Carousel/Carousel";
import DesktopFineTable from "../../components/Landing/DesktopFineTable/DesktopFineTable";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import MobileFineTable from "../../components/Landing/MobileFineTable/MobileFineTable";
import ReactLoading from "react-loading";
import SearchByView from "../../components/Landing/SearchByView/SearchByView";
import SearchView from "../../components/Landing/SearchView/SearchView";
import { getProfile } from "../../api/auth";
import { setAuthLoading } from "../../store/auth/authActions";
import { setHandbackStatus } from "../../store/fine/handbackActions";
import { setPaymentStatus } from "../../store/fine/paymentStatusActions";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { validateLACode } from "../../utils/COCTFilter";
import axios from "axios";
import appConfig from "../../config";

const Landing = () => {

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  let urlNo = searchParams.get("infringement");
  const searchedID = useAppSelector((state) => state.fine.searchedID);
  const [infringementNumber, setInfringementNumber] = useState<string | null>(
    urlNo ? urlNo : searchedID ? searchedID : ""
  );
  const [errorMessage, setErrorMessage] = useState<string | null>("");
  const user = useAppSelector((state) => state.auth.user);
  const authLoading = useAppSelector((state) => state.auth.loading);
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 480);
  const searchBy = useAppSelector((state) => state.fine.searchBy);
  const idFines = useAppSelector((state) => state.fine.idFines);

  useEffect(() => {
    clearReferenceKey();
    user && getProfile(true);
    dispatch(setPaymentStatus(null));
    dispatch(setAuthLoading(false));
    // dispatch(setSearchedID(null));
    dispatch(setHandbackStatus(false));
  }, []);
  useEffect(() => {
    if (idFines && idFines.length > 0 && searchedID) searchByID(searchedID!);
  }, []);

  const clearReferenceKey = async () => {
    await localStorage.removeItem("referenceKey");
  };

  const validateID = (id: string) => {
    var idPattern =
      /^(((\d{2}((0[13578]|1[02])(0[1-9]|[12]\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\d|30)|02(0[1-9]|1\d|2[0-8])))|([02468][048]|[13579][26])0229))(( |-)(\d{4})( |-)(\d{3})|(\d{7}))/;
    return id && idPattern.test(id.replace(/ /g, ""));
  };



  const onContinueClicked = async (token: string, version: boolean) => {
    if (!infringementNumber || infringementNumber === "") {
      if (searchBy === SearchBy.INFRINGEMENT_NUMBER) {
        setErrorMessage("Please enter a notice number");
      } else {
        setErrorMessage("Please enter an ID number");
      }
      return;
    }
    dispatch(setIDFines(null));
    setLoading(true);
        dispatch(setAcceptTerms(false));
        dispatch(setAcceptGuilt(false));
        if (searchBy === SearchBy.INFRINGEMENT_NUMBER) {
          if (!/^[A-Za-z0-9\/]{5,36}$/.test(infringementNumber?.trim()!)) {
            setErrorMessage("Please enter a valid notice number");
            setLoading(false);
          } else {
            if (infringementNumber?.trim()) {
              handleInfringement(infringementNumber, token, version);
            } else {
              setErrorMessage("Please enter a notice number");
            }
          }
        } else {
          if (!infringementNumber || !validateID(infringementNumber?.trim()!)) {
            setLoading(false);
            setErrorMessage("Please enter a valid ID number");
          } else {
            handleIDNumber(token, version);
          }
        }


  };

  const handleIDNumber = async (token: string, version: boolean) => {
    setErrorMessage(null);
    const resp: any = await searchByID(infringementNumber!, token, version);
    if (!resp.status) {
      if (resp.errors) {
        Object.keys(resp.errors).map((e) => {
          setErrorMessage(resp.errors[e]);
        });
      }
    }
    setLoading(false);
  };

  const handleInfringement = async (infringement: string, token = 'loggedIn', version = false) => {
    setErrorMessage(null);
    if (searchBy === SearchBy.ID_NUMBER) {
      dispatch(setAuthLoading(true));
    }

    if (infringementNumber && searchBy === SearchBy.INFRINGEMENT_NUMBER) {
      if (!validateLACode(infringementNumber)) {
        setLoading(false);
        setErrorMessage(
          "Not a CoCT infringement. This can be paid <a href='https://payat.io/qr/" +
            infringementNumber.replace(/\//g, "") +
            "?tt=2' target='_blank'>here.</a>"
        );
        return;
      }
    }
    const resp: any = await search(infringement, token, version);
    if (resp.status) {
      dispatch(setCurrentStep(1));
      dispatch(setAccount(infringement));
      navigate("/fine");
    } else if (searchBy === SearchBy.INFRINGEMENT_NUMBER) {
      setErrorMessage(resp.message);
    }
    if (searchBy === SearchBy.ID_NUMBER) {
      dispatch(setAuthLoading(false));
    }
    setLoading(false);
    return true;
  };

  return (
    <div className="landing-container">
      {authLoading && (
        <>
          <div className="register-overlay" style={{ zIndex: 2 }} />
          <div
            style={{
              position: "absolute",
              marginTop: "50vh",
              zIndex: 3,
            }}
          >
            <ReactLoading type="bubbles" color="#e97700" />
          </div>
        </>
      )}
      <Header />
      <div className="landing-content">
        <div>
          <img src={COCTSVG} alt="" />
          <p className="landing-title">City of Cape Town - Traffic Fines</p>
        </div>

        <div className="infringement-container">
          {!searchBy ? (
            <SearchByView setErrorMessage={setErrorMessage} urlNo={urlNo} />
          ) : (
            <SearchView
              infringementNumber={infringementNumber}
              setInfringementNumber={setInfringementNumber}
              loading={loading}
              errorMessage={errorMessage}
              onContinueClicked={onContinueClicked}
            />
          )}
        </div>
        {searchBy === SearchBy.ID_NUMBER ? (
          idFines && idFines.length > 0 ? (
            <div className="id-fines-container">
              <p className="id-fines-heading">
                We found {idFines.length} City of Cape Town fines linked to this
                ID Number:
              </p>

              {!isMobile ? (
                <DesktopFineTable
                  handleInfringement={(infringement: string, token: string, version: boolean) =>
                    handleInfringement(infringement, token, version)
                  }
                />
              ) : (
                <MobileFineTable
                  handleInfringement={(infringement: string, token: string, version: boolean) =>
                    handleInfringement(infringement, token, version)
                  }
                />
              )}
            </div>
          ) : idFines ? (
            <div className="id-fines-container">
              <p className="id-fines-heading">
                There are no fines linked to this ID Number.
              </p>
            </div>
          ) : null
        ) : null}
      </div>
      <Carousel />
      <Footer />
    </div>
  );
};

export default Landing;
